import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { environment } from '../config/environment';
import { apiRequest } from '../services/apiClient';
import createSidebarSections from '../config/sidebarSections';
import DashboardLayout from '../components/DashboardLayout';
import './WelcomePage.css';

const WelcomePage = () => {
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState('Rakesh');

  const userName = useMemo(() => {
    const userStr = localStorage.getItem('authUser') || sessionStorage.getItem('authUser');
    if (!userStr) return '';

    try {
      const user = JSON.parse(userStr);
      return user?.name || user?.fullName || user?.email || '';
    } catch {
      return '';
    }
  }, []);

  useEffect(() => {
    const applyName = async () => {
      try {
        const validateResponse = await apiRequest(
          environment.endpoints.validate,
          {
            method: 'POST',
          },
          { skipValidation: true }
        );

        const validateData = validateResponse?.data;
        const apiUserName = validateData?.data?.username;
        const normalizedName = typeof apiUserName === 'string' ? apiUserName.trim() : '';

        setDisplayName(normalizedName || userName || 'Rakesh');
      } catch {
        setDisplayName(userName || 'Rakesh');
      }
    };

    applyName();
  }, [userName]);

  const handleLogout = async () => {
    try {
      await apiRequest(
        environment.endpoints.logout,
        {
          method: 'POST',
        },
        { skipValidation: true }
      );
    } catch {
      // Ignore logout API failure and continue client-side cleanup.
    } finally {
      localStorage.removeItem('authUser');
      sessionStorage.removeItem('authUser');
      localStorage.setItem('logoutRequested', 'true');
      sessionStorage.setItem('logoutRequested', 'true');
      navigate('/login', { replace: true });
    }
  };

  const sections = useMemo(
    () => createSidebarSections(navigate, null),
    [navigate]
  );

  return (
    <DashboardLayout
      displayName={displayName}
      pageTitle="Welcome"
      dashboard={{
        active: true,
        onClick: () => navigate('/welcome'),
      }}
      sections={sections}
      onLogout={handleLogout}
    >
      <section className="dashboard-card blank-view">
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h3>Welcome to Dashboard</h3>
          <p>Select an option from the sidebar to get started.</p>
        </div>
      </section>
    </DashboardLayout>
  );
};

export default WelcomePage;